const roundNumber = function(
    num: number | string,
    decimals: number = 2
) {
	const value = Number(num);

    if (isNaN(value)) {
        throw new Error('Invalid number');
    }

    const factor = Math.pow(10, decimals);

    return Math.round((value + Number.EPSILON) * factor) / factor;
	
    // const factor = Math.pow(10, decimals);
    // return Math.round((num + Number.EPSILON) * factor) / factor;
}

export {
	roundNumber
}